module.exports = __webpack_public_path__ + "img/news2.3ab4ef37.png";